import { t } from "i18next";
import { FC } from "react";
import { Col, Container, Row } from "react-bootstrap";

import LoadingButton from "@app/components/Button";
import BootstrapModal from "@app/components/Modal";

interface AlertModalProps {
    showModal: boolean;
    setShowModal: (_show: boolean) => void;
    submitAlert: () => void;
}

const AlertModal: FC<AlertModalProps> = ({ showModal, setShowModal, submitAlert }) => (
    <>
        <BootstrapModal
            open={showModal}
            onClose={() => setShowModal(false)}
            header={t("MODAL.ALERT_MODAL.HEADER")}
        >
            <Container className='alert-modal-container'>
                <Row className='mt-4'>
                    <Col>{t("MODAL.ALERT_MODAL.BODY")}</Col>
                </Row>
                <Row className='add-branch__viewPasskeyBtns mt-4'>
                    <LoadingButton
                        variant='cancel'
                        label={t("COMMON.NO")}
                        onClick={() => setShowModal(false)}
                    />
                    <LoadingButton
                        variant='submit'
                        label={t("COMMON.YES")}
                        onClick={() => {
                            submitAlert();
                            setShowModal(false);
                        }}
                    />
                </Row>
            </Container>
        </BootstrapModal>
    </>
);

export default AlertModal;
